import TabItem from './TabItem';

export default TabItem;
